import camelcaseKeys from 'camelcase-keys';

import { EmailAutomationTimeframes } from '../../../constants/emailAutomations';

export const sortAutomationSteps = steps => {
  if (!steps) {
    return [];
  }

  const daysBeforeSteps = [];
  const daysOnSteps = [];
  const daysAfterSteps = [];

  steps.forEach(step => {
    const normalizedStep = camelcaseKeys(step, { deep: true });

    if (normalizedStep.timeframeType === EmailAutomationTimeframes.DaysBefore) {
      daysBeforeSteps.push(normalizedStep);
    } else if (normalizedStep.timeframeType === EmailAutomationTimeframes.OnDayOf) {
      daysOnSteps.push(normalizedStep);
    } else if (normalizedStep.timeframeType === EmailAutomationTimeframes.DaysAfter) {
      daysAfterSteps.push(normalizedStep);
    }
  });

  return [
    ...daysBeforeSteps.sort((a, b) => b.timeframeValue - a.timeframeValue),
    ...daysOnSteps,
    ...daysAfterSteps.sort((a, b) => a.timeframeValue - b.timeframeValue)
  ];
};

